export default [
  {
    title: '考核月份',
    key: 'reportTime',
    width: 50
  },
  {
    title: '姓名',
    key: 'name',
    width: 60
  },
  {
    title: '游戏组',
    key: 'gameName',
    width: 90
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 68
  },
  {
    title: '实际消耗金额',
    key: 'amount',
    sortable: 'custom',
    width: 88
  },
  {
    title: '30日角色分成后金额',
    key: 'thirtySynthesizeMoney',
    sortable: 'custom',
    width: 110
  },
  {
    title: '30日激活分成后金额',
    key: 'thirtySynthesizeDeviceMoney',
    sortable: 'custom',
    width: 110
  },
  {
    title: '30日创角(账号)分成后金额',
    key: 'thirtySynthesizeCreateRoleMoney',
    sortable: 'custom',
    width: 132
  },
  {
    title: '30日角色回款率',
    key: 'thirtySynthesizeRetain',
    sortable: 'custom',
    width: 90
  },
  {
    title: '30日激活回款率',
    key: 'thirtySynthesizeDeviceRetain',
    sortable: 'custom',
    width: 90
  },
  {
    title: '30日创角(账号)回款率',
    key: 'thirtySynthesizeCreateRoleRetain',
    sortable: 'custom',
    width: 118
  },
  {
    title: '30日回款KPI',
    key: 'thirtyDayKpi',
    width: 68
  },
  {
    title: '角色回款奖金系数',
    key: 'roleBonusDivisor',
    width: 86
  },
  {
    title: '激活回款奖金系数',
    key: 'activeBonusDivisor',
    width: 86
  },
  {
    title: '创角回款奖金系数',
    key: 'createRoleBonusDivisor',
    width: 86
  },
  {
    title: '100w系数',
    key: 'millionRatio',
    width: 60
  },
  {
    title: '角色回款奖金金额',
    key: 'roleBonus',
    sortable: 'custom',
    width: 98
  },
  {
    title: '激活回款奖金金额',
    key: 'activeBonus',
    sortable: 'custom',
    width: 98
  },
  {
    title: '创角回款奖金金额',
    key: 'createRoleBonus',
    sortable: 'custom',
    width: 105
  },
  {
    title: '操作',
    key: 'control',
    width: 56
  }
]
